"use client";

import Link from "next/link";
import { useEffect, useState } from "react";
import { apiGet, apiPost } from "../components/api";

type Device = {
  id: string;
  name: string;
  location?: string | null;
  status: string;
};

export default function DashboardPage() {
  const [devices, setDevices] = useState<Device[]>([]);
  const [name, setName] = useState("");
  const [location, setLocation] = useState("");
  const [status, setStatus] = useState("Idle");
  const [error, setError] = useState<string | null>(null);

  const loadDevices = async () => {
    setError(null);
    try {
      const data = await apiGet<{ devices: Device[] }>("/v1/devices");
      setDevices(data.devices);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Failed to load devices");
    }
  };

  useEffect(() => {
    void loadDevices();
  }, []);

  const onCreate = async () => {
    setError(null);
    try {
      await apiPost("/v1/devices", {
        name,
        location: location || undefined,
        status
      });
      setName("");
      setLocation("");
      setStatus("Idle");
      await loadDevices();
    } catch (err) {
      setError(err instanceof Error ? err.message : "Create failed");
    }
  };

  return (
    <div className="page">
      <nav className="nav">
        <div className="brand">AudioHawk</div>
        <div className="links">
          <Link href="/">Home</Link>
          <Link href="/login">Logout</Link>
        </div>
      </nav>

      <main className="hero">
        <div>
          <div className="section-title">Fleet Overview</div>
          <h1>Device control panel.</h1>
          <p>Manage your AudioHawk units and monitor their status.</p>
          {error ? <div style={{ color: "var(--muted)" }}>{error}</div> : null}
        </div>

        <div className="card">
          <h2>Create Device</h2>
          <form
            className="form"
            onSubmit={(event) => {
              event.preventDefault();
              void onCreate();
            }}
          >
            <div>
              <label>Name</label>
              <input
                type="text"
                placeholder="AH-101"
                value={name}
                onChange={(event) => setName(event.target.value)}
              />
            </div>
            <div>
              <label>Location</label>
              <input
                type="text"
                placeholder="Field Sector 9"
                value={location}
                onChange={(event) => setLocation(event.target.value)}
              />
            </div>
            <div>
              <label>Status</label>
              <input
                type="text"
                placeholder="Idle"
                value={status}
                onChange={(event) => setStatus(event.target.value)}
              />
            </div>
            <button className="button" type="submit">
              Add Device
            </button>
          </form>
        </div>

        <div className="card">
          <h2>Devices</h2>
          <div className="grid">
            {devices.map((device) => (
              <div key={device.id} className="card" style={{ padding: 16 }}>
                <div className="section-title">{device.name}</div>
                <div>{device.location ?? "Unknown"}</div>
                <div style={{ color: "var(--muted)", marginTop: 6 }}>
                  {device.status}
                </div>
              </div>
            ))}
          </div>
        </div>
      </main>
    </div>
  );
}
